__turbopack_context__.v({
  "accordionRoot": "AccordionBlok-module__0ljUFW__accordionRoot",
  "blok-big-title": "AccordionBlok-module__0ljUFW__blok-big-title",
  "blok-subtitle": "AccordionBlok-module__0ljUFW__blok-subtitle",
  "blok-title": "AccordionBlok-module__0ljUFW__blok-title",
  "center": "AccordionBlok-module__0ljUFW__center",
  "full": "AccordionBlok-module__0ljUFW__full",
  "left": "AccordionBlok-module__0ljUFW__left",
  "right": "AccordionBlok-module__0ljUFW__right",
  "title": "AccordionBlok-module__0ljUFW__title",
});
